var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 82,
    viewBox: "0 0 64 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 34.8242,
    width: 63.1978,
    height: 47.1758,
    rx: 9,
    fill: "#F2CA00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6262 38.3846V21.4725C51.6262 10.1659 42.4603 1 31.1537 1V1C19.847 1 10.6812 10.1658 10.6812 21.4725V38.3846",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6812 62.8628L19.1372 54.4067M19.1372 62.8628L11.1262 54.8518",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1479 62.8628L35.604 54.4067M35.604 62.8628L27.593 54.8518",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0601 62.8628L52.5161 54.4067M52.5161 62.8628L44.5051 54.8518",
    stroke: "#1C1919",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.67ab4858bee9e6f6a21cdfad66a83ea4.svg";
export { ForwardRef as ReactComponent };